import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { SitecoreContext } from '../types/sitecoreContextProps'

const useSitecoreContextCustom = (): SitecoreContext => {
  const { sitecoreContext } = useSitecoreContext()
  return sitecoreContext as unknown as SitecoreContext
}

export default useSitecoreContextCustom
